<template>
  <!-- <div class="wrapper" :class="postFile"> -->
  <div>
    <div class="wrapper">
      <div class="header-container container cleafix">
        <div class="brand">
          <img class="img-fluid" :src="imgUrl" />
        </div>
        <div class="float-right">
          <ul class="nav nav-inline">
            <li data-menuanchor="firstPage" class="menuList">
              <a href="#first" class="active">首页</a>
            </li>
            <!-- <li data-menuanchor="secondPage" class="menuList">
              <a href="#second">解决方案</a>
            </li>
            <li data-menuanchor="thirdPage" class="menuList">
              <a href="#third">入驻流程</a>
            </li>
            <li data-menuanchor="fourthPage" class="menuList">
              <a href="#fourth">展示案例</a>
            </li> -->
            <router-link tag = 'li' to='/download' class="menuList">
                <a target="_blank">操作手册</a>
            </router-link>
            <!-- <li data-menuanchor="fourthPage" class="menuList">
              <a  @click="toDownload(item.path)">操作手册</a>
            </li> -->
            <router-link tag='li' to='/expense' class="menuList">
                <a target='_blank'>费用说明</a>
            </router-link>
            <!-- <li data-menuanchor="sixPage" class="menuList">
              <a>费用说明</a>
            </li> -->
            <li data-menuanchor="sevenPage" class="menuList">
              <a href="https://geju.gzyueyun.com:8443/xhpc/login.html" target="_blank">协会管理系统</a>
            </li>
          </ul>
          <div class="tel text-main border border-main">
            {{tel}}
            <i class="icon-font">&#xe620;</i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div>
    <div class="header">
      <div class="logo">
        <img src="../../../assets/images/logo_gejuyun.png" alt />
      </div>
      <ul id="myMenu">
        <li data-menuanchor="firstPage" class="menuList">
          <a href="#first" class="active">首页</a>
        </li>
        <li data-menuanchor="secondPage" class="menuList">
          <a href="#second">解决方案</a>
        </li>
        <li data-menuanchor="thirdPage" class="menuList">
          <a href="#third">入注流程</a>
        </li>
        <li data-menuanchor="fourthPage" class="menuList">
          <a href="#fourth">展示案例</a>
        </li>
        <li data-menuanchor="fourthPage" class="menuList" @click="toDownload(item.path)" >
          <a>操作手册</a>
        </li>
        <li data-menuanchor="sixPage" class="menuList">
          <a href="#six">费用说明</a>
        </li>
        <li data-menuanchor="sevenPage" class="menuList">
          <a href="https://geju.gzyueyun.com:8443/xhpc/login.html" target="_blank">协会管理系统</a>
        </li>
      </ul>
      <div class="telphone">
        <span>020-37579981</span>
        <img src="../../../assets/images/icon_telephone.png" alt="咨询电话" />
      </div>
    </div>
  </div>-->
</template>

<script>
import logo from "../../../assets/images/logo_gejuyun.png";
import $ from "jquery";
export default {
  name: "Header",
  props: {
    items: ""
  },
  data() {
    return {
      tel: "020-37579981",
      actId: 0,
      isActive: -1,
      imgUrl: logo
    };
  },
  methods: {
    association: function(e) {
      window.open(e);
    },
    toDownload() {
      this.$router.push({
        path: "/download"
      });
    },
    toExpense(index) {
      this.$router.push({
        path: "/expense"
      });
      this.isActive = index;
    }
  }
};
</script>

<style scoped>
@import "app-header.css";
/* .searchBarFixed{
        position: fixed;
        z-index: 99;
        width: 100%;
        box-shadow:0px 15px 10px -20px #000;
    } */
.wrapper {
  position: fixed;
  z-index: 999;
  background: #fff;
  opacity: 0.88;
}
.isFixed {
  position: fixed;
  width: 100%;
  background-color: #fff;
  top: 0;
  z-index: 999;
  box-shadow: 0px 15px 10px -20px #000;
  opacity: 0.8;
}
/* .nav li a.active {
  color: #f00;
} */
/* .nav li a.active{
  padding:2px 1px;
  color:#38adff;
  font-weight:600;
  border-bottom:2px solid #38adff;
} */
.header {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  z-index: 11;
  width: 100%;
  background: #fff;
  opacity: 0.9;
  justify-content: center;
  align-items: center;
  padding: 12px 30px;
}
.logo {
  width: 249px;
  height: 65px;
  padding: 0 60px 0 20px;
}
.logo img {
  width: 100%;
  height: 100%;
}
#myMenu {
  display: flex;
  padding: 0 15px 0 0;
}

#myMenu li {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
}
#myMenu li a {
  flex: 1;
  display: block;
  font-size: 18px;
  color: #333;
  cursor: pointer;
}
#myMenu li a.active {
  padding: 2px 1px;
  color: #38adff;
  font-weight: 600;
  border-bottom: 2px solid #38adff;
}
.telphone {
  border: 1px solid #3399ff;
  border-radius: 18px;
  padding: 5px 15px;
  color: #38adff;
  font-size: 20px;
  display: flex;
  align-items: center;
}
.telphone img {
  width: 20px;
  height: 20px;
  padding-left: 5px;
}
</style>
